const fields = (new Array(3)).fill(null);

const InformationLoading = () => (
    <div className="bg-white p-2 sm:p-4 rounded-2xl shadow-md flex flex-col gap-5 select-none ">
        <div className="flex flex-1 flex-col gap-3">
            <div className="bg-gray-200 w-full animate-pulse h-3 rounded-2xl" />
            <div className="bg-gray-200 w-full animate-pulse h-3 rounded-2xl" />
            <div className="bg-gray-200 w-full animate-pulse h-3 rounded-2xl" />
            <div className="bg-gray-200 w-full animate-pulse h-3 rounded-2xl" />
        </div>
        {fields.map((_, index) => (
            <div key={index} className="flex flex-1 flex-col gap-3">
                <div className="bg-gray-200 w-full animate-pulse h-3 rounded-2xl" />
                <div className="bg-gray-200 w-full animate-pulse h-12 rounded-2xl" />
            </div>
        ))}
        <div className="flex flex-1 flex-col gap-3">
            <div className="bg-gray-200 w-full animate-pulse h-3 rounded-2xl" />
            <div className="h-52 w-full rounded-xl bg-gray-200 animate-pulse" />
        </div>
    </div>
);

export default InformationLoading;